module.exports = __webpack_public_path__ + "static/ITTalent-5c315b1ef7afcafef92df32a1cb8fd97.png";